import { CompassArrow, CompassBase } from "components/Icons";

import styles from "./styles.module.scss";

const Compass = () => {
  return (
    <div className={styles.compass}>
      <CompassBase className={styles.base} />
      <CompassArrow className={styles.arrow} />
    </div>
  );
};

export default Compass;
